import { JavelinaBaseClient } from './JavelinaBaseClient'

export class JavelinaAccumulatorClient extends JavelinaBaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    /**
     * @description returns a family accums object for a specific product and year
     * @param {String} employeeId the JV employeeId
     * @param {String} product Product ID - M=Medical, D=Dental, V=Vision, P-Perscription, H=HSA
     * @param {String} year Year - 2017, 2018, etc.
     * @param {number} depSeqNum Dependent Sequence Number
     */
    async getFamilyAccums(employeeId, product, year, depSeqNum) {
        await this.createSecureAxiosInstance()

        const params = {
            employeeid: employeeId,
            product: product,
            year: year,
            depsequencenumber: depSeqNum
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/eligibility/memberaccumulators`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }
}
